import { render, staticRenderFns } from "./WelfarePopup.vue?vue&type=template&id=d26c0dba&scoped=true"
import script from "./WelfarePopup.vue?vue&type=script&lang=js"
export * from "./WelfarePopup.vue?vue&type=script&lang=js"
import style0 from "./WelfarePopup.vue?vue&type=style&index=0&id=d26c0dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26c0dba",
  null
  
)

export default component.exports